module.exports = __webpack_public_path__ + "img/bioexcel.58e076a3.png";